import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiChevronDown } from "react-icons/hi";

export interface IProps {
  title: string;
  currrentValue: string;
  onClick: (value: string) => void;
  selectionList: string[];
}
function SelectSearchBarComponent({...props}: IProps) {
  const { i18n, t } = useTranslation();
  const [showList, setShowList] = useState<boolean>(false);

  return (
    <div className="mobile:w-full tablet:w-full relative">
      <div
        onClick={() => {
          setShowList(!showList);
        }}
        className={`${
          i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
        } flex w-[215px] mobile:w-full tablet:w-full items-center justify-between cursor-pointer`}
      >
        <div
          className={`${
            i18n.language === "ar" ? "mobile:mr-3" : "mobile:ml-3"
          } flex flex-col mobile:gap-2 tablet:gap-2`}
        >
          <div
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
            className={`${
              i18n.language === "ar" ? "text-2xl" : "text-xl"
            } font-arMedium mobile:text-base text-zinc-600`}
          >
            {t(props.title)}
          </div>
          <div
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
            className={`${
              i18n.language === "ar" ? "text-right" : "text-left"
            } font-ar text-lg text-zinc-500 mobile:text-sm truncate w-[183.56px] mobile:w-full tablet:w-full`}
          >
            {props.currrentValue}
          </div>
        </div>
        <HiChevronDown
          className={`${
            i18n.language === "ar" ? "mobile:ml-3" : "mobile:mr-3"
          } text-zinc-600 text-2xl`}
        />
        {showList ? (
          <div
            dir={i18n.language === "ar" ? "ltr" : "rtl"}
            className={`${
              i18n.language === "ar"
                ? "-mr-8 mobile:-mr-0 tablet:-mr-0"
                : "-ml-8 mobile:-ml-0 tablet:-ml-0"
            } absolute top-[100px] w-[280px] h-fit max-h-[256px] bg-slate-50 rounded z-40 mobile:w-full mobile:h-[216px] mobile:top-[75px] tablet:w-full tablet:h-[216px] tablet:top-[75px] shadow-md py-2 px-3.5 overflow-y-auto`}
          >
            <div className="flex flex-col items-end">
              {props.selectionList.map((item, index) => (
                <div key={index} className="w-full">
                  <p
                    onClick={() => props.onClick(item)}
                    className={`${
                      i18n.language === "ar" ? "pr-4" : "pl-4"
                    } flex flex-col items-end justify-center font-ar text-M3 text-base w-full h-10 hover:bg-slate-200 hover:rounded`}
                  >
                    {item}
                  </p>
                  <div className="bg-slate-300 w-full h-[0.3px]"></div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default SelectSearchBarComponent;
